<template>
	<div class="list">
		<div class="list__header">
			<template v-if="mobile">
				<presi-candidate :candidate="candidate" :type="'header'" />
			</template>
			<template v-else>
				Les résultats pour {{candidate.full_name_clean}}
			</template>
		</div>
		<div class="list__polls">
			<collapsable>
				<div class="polls">
					<div v-for="(poll, p) in candidate.polls" class="poll" :key="candidate.name + '-poll' + p">
						<div class="poll__score">
							{{poll.scoreTxt}}&nbsp;%
						</div>
						<div class="poll__org">
							<a target="_blank" :href="poll.info.link">Sondage {{poll.info.organization}}</a> du {{poll.dateTxt}}<template v-if="poll.info.hypothesis != 'Hypothèse sans nom'">, {{poll.info.hypothesis.replace('Hyp','hyp')}}</template>
						</div>
					</div>
				</div>
			</collapsable>
		</div>
	</div>
</template>
<script>
	import PresiCandidate from 'global/components/PresiCandidate'
	import Collapsable from 'global/components/Collapsable'
	export default {
		name: 'PollsList',
		components: { PresiCandidate, Collapsable },
		props: {
			candidate: {
				type: Object,
				required: true,
			},
			mobile: {
				type: Boolean,
				default: false,
			}
		},
	}
</script>
<style lang="scss">
	@import 'global/css/contexte.apps.colors'; 
	.list {
		margin-bottom: 2em;
	}
	.poll {
		display: flex;
		margin-bottom: .7em;
		&__score {
			flex: 0 0 55px;
			font-size: 1.2em;
		}
		&__org {
			color: $medium-grey;
			flex: 1 1 auto;
			font-size: .9em;
		}
	}
	@media screen and (min-width: 600px)  {
		.list {
			&__header {
				padding-top: .7em;
				border-top: 1px solid $light-grey;
				margin-bottom: 1em;
			}
		}
		.poll {
			margin-bottom: .2em;
			&__score {
				font-size: 1.1em;
			}
			&__org {
				font-size: .85em;
			}
		}
	}
</style>